import { FinishReasonSchema } from "@perceptron/api/apiContracts/chatCompletions";
import { z } from "zod";

import type {
  ToolCallCompletedEvent,
  ToolCallFailedEvent,
  ToolCallLinkEvent,
  ToolCallStartedEvent,
} from "@demo/server/api/contracts/toolCall";
/**
 * SSE Event types for streaming responses
 */
export enum RunEventType {
  USAGE = "usage",
  ERROR = "error",
  TOOL_CALL_STARTED = "tool_call_started",
  TOOL_CALL_LINK = "tool_call_link",
  TOOL_CALL_COMPLETED = "tool_call_completed",
  TOOL_CALL_FAILED = "tool_call_failed",
}

/**
 * SSE Event data types
 */
export interface RunDefaultChunk {
  content?: string;
  reasoning_content?: string;
  finish_reason?: z.infer<typeof FinishReasonSchema>;
  timestamp: string;
}

export interface RunUsageChunk {
  timestamp: string;
  usage: {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
  };
}

export interface RunErrorChunk {
  error: string;
  timestamp?: string;
}

export type RunEventData =
  | RunDefaultChunk
  | RunUsageChunk
  | RunErrorChunk
  | ToolCallStartedEvent
  | ToolCallLinkEvent
  | ToolCallCompletedEvent
  | ToolCallFailedEvent;

/**
 * SSE Event interface for structured streaming
 */
export interface RunSSEEvent {
  event?: RunEventType;
  data: RunEventData;
}
